import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  connectorService,
  CreateConnectorRequest,
  UpdateConnectorRequest,
} from '../../services/api/connectorService';

export const fetchConnectorCatalog = createAsyncThunk(
  'connector/fetchConnectorCatalog',
  async (_, { rejectWithValue }) => {
    try {
      return await connectorService.getCatalog();
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to fetch connector catalog');
    }
  }
);

export const fetchConnectors = createAsyncThunk(
  'connector/fetchConnectors',
  async (params: { type?: string; scope?: string } = {}, { rejectWithValue }) => {
    try {
      return await connectorService.getConnectors(params);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to fetch connectors');
    }
  }
);

export const createConnector = createAsyncThunk(
  'connector/createConnector',
  async (payload: CreateConnectorRequest, { rejectWithValue }) => {
    try {
      return await connectorService.createConnector(payload);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to create connector');
    }
  }
);

export const updateConnector = createAsyncThunk(
  'connector/updateConnector',
  async ({ id, payload }: { id: number; payload: UpdateConnectorRequest }, { rejectWithValue }) => {
    try {
      return await connectorService.updateConnector(id, payload);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to update connector');
    }
  }
);

export const deleteConnector = createAsyncThunk(
  'connector/deleteConnector',
  async (id: number, { rejectWithValue }) => {
    try {
      await connectorService.deleteConnector(id);
      return id;
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to delete connector');
    }
  }
);

export const activateConnector = createAsyncThunk(
  'connector/activateConnector',
  async (id: number, { rejectWithValue }) => {
    try {
      return await connectorService.activateConnector(id);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to activate connector');
    }
  }
);

export const deactivateConnector = createAsyncThunk(
  'connector/deactivateConnector',
  async (id: number, { rejectWithValue }) => {
    try {
      return await connectorService.deactivateConnector(id);
    } catch (error: any) {
      return rejectWithValue(error.message ?? 'Failed to deactivate connector');
    }
  }
);
